/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React from 'react';
import StringResources from 'nls/StringResources';
import { SVGIcon } from '@ba/ba-ui-carbon-toolkit';

import emBuildExploration from '@ba/ba-graphics/dist/illustrations-js/build-exploration_200';

import './marketing.scss';

const Marketing = function() {
	return (
		<div className="explore-marketing">
			<SVGIcon themable intent={'primary'} iconId={emBuildExploration.id} height={256} width={256} />
			<div className="explore-marketing__title">{StringResources.get('startingPoints_marketing_title')}</div>
			<div className="explore-marketing__description">{StringResources.get('startingPoints_marketing_text')}</div>
			<div className="explore-marketing__description">{StringResources.get('startingPoints_marketing_add_data')}</div>
		</div>
	);
};

export default Marketing;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/Marketing.js